import { Button } from "../common/Button";
import { Card } from "../common/Card";
import { formatDateOnly } from "../../services/hiveActions";

/**
 * "Was this payment entered twice?" (V147)
 *
 * Same outlet, same amount, same day, recorded more than once. Two
 * instalments of one size are normal, so this ASKS and never merges or
 * deletes. "Entered twice" records a reversing payment; both original
 * rows stay, which is how every correction in this ledger is made.
 * Appears only when there is something to answer.
 */
export function PaymentDuplicateQuestions({ flags = [], onResolve, busyId = null }) {
  if (!flags.length) return null;
  return (
    <Card
      title={flags.length === 1 ? "One payment needs checking" : `${flags.length} payments need checking`}
      className="section-spacing"
    >
      <p style={{ color: "var(--color-text-muted)", marginTop: 0 }}>
        The same amount from the same outlet on the same day was recorded more than once. It does not mean
        anyone did anything wrong.
      </p>
      {flags.map((f) => {
        const busy = busyId === f.flag_id;
        return (
          <div key={f.flag_id} style={{ borderTop: "1px solid var(--color-border)", paddingTop: "0.75rem", marginTop: "0.75rem" }}>
            <strong>{f.client_name}</strong>: ${Number(f.amount).toFixed(2)} on {formatDateOnly(f.received_date)}
            <ul style={{ margin: "0.5rem 0", paddingLeft: "1.25rem" }}>
              {(f.payments || []).map((p) => (
                <li key={p.payment_id}>
                  Payment #{p.payment_id}
                  {p.created_by_label ? `, entered by ${p.created_by_label}` : ""}
                  {p.method ? `, ${p.method}` : ""}
                  {p.notes ? ` ("${p.notes}")` : ""}
                </li>
              ))}
            </ul>
            <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
              <Button size="sm" variant="secondary" loading={busy} onClick={() => onResolve(f.flag_id, "both_real")}>
                Both were real
              </Button>
              <Button size="sm" loading={busy} onClick={() => onResolve(f.flag_id, "reverse_second")}>
                Entered twice: reverse the second
              </Button>
            </div>
          </div>
        );
      })}
    </Card>
  );
}
